export default "__VITE_ASSET__1412fd37__"